/**
 * F-02: 燃料油価格の入力バリデーション（純関数）。
 *
 * - 基準価格 (haioku / regular / keiyu / touyu): 50〜300 の整数
 * - 一覧価格 (fuel_settings の区分 × 4 燃料 / F-16 で区分は可変): 50〜500 の整数
 *
 * いずれも { valid, error? } を返す。`error` は UI にそのまま表示する想定。
 * F-03 の Callable 側でも同等の検証を行うが、UI でも事前ガードしてラウンドトリップを抑える。
 */

export interface ValidationResult {
  valid: boolean;
  error?: string;
}

/** 基準価格の許容下限（円）。input の `min` 属性と合わせて使う。 */
export const BASE_MIN = 50;
/** 基準価格の許容上限（円）。input の `max` 属性と合わせて使う。 */
export const BASE_MAX = 300;
/** 一覧価格の許容下限（円）。 */
export const LIST_MIN = 50;
/** 一覧価格の許容上限（円）。 */
export const LIST_MAX = 500;

function isFiniteInteger(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value) && Number.isInteger(value);
}

function validateRange(value: unknown, min: number, max: number): ValidationResult {
  if (!isFiniteInteger(value)) {
    return { valid: false, error: '整数で入力してください' };
  }
  if (value < min || value > max) {
    return { valid: false, error: `${min}〜${max} の整数で入力してください` };
  }
  return { valid: true };
}

/** 基準価格（haioku / regular / keiyu / touyu）の検証。50〜300 の整数。 */
export function validateBasePrice(value: unknown): ValidationResult {
  return validateRange(value, BASE_MIN, BASE_MAX);
}

/** 一覧価格（一覧表の各区分 × 燃料セル）の検証。50〜500 の整数。 */
export function validateListPrice(value: unknown): ValidationResult {
  return validateRange(value, LIST_MIN, LIST_MAX);
}
